<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Optional Org Id to fetch the summary for instead of flow owner:
            <input type="text" [(ngModel)]="seConfiguration.OrgIdToFetchSummaryFor" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the Organization ID value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.OrgIdContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the Historical Organization ID value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.HistoricalOrgIdContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the minimum bonding required value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.requiredFAContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the bonding provided value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.providedFAContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the minimum insurance required value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.requiredInsuranceContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the insurance provided value to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.providedInsuranceContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the org's brine hauler status to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.isBrineHaulerContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the org's active financial statement status to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.hasActiveFinancialStatementContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the org's number of domestic wells last transferred after June 30, 2010 to be saved to the context:
            <input type="text" [(ngModel)]="seConfiguration.numberOfPostJune2010DomesticWellsContextTarget" />
        </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>
            Path for the org's number of domestic wells last transferred after the current financial statement (if any) was last reviewed:
            <input type="text" [(ngModel)]="seConfiguration.numberOfDomesticWellsSinceFinancialStatementReviewContextTarget" />
        </label>
    </div>
</div>